import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@gemini/ui";
import { PrintIcon } from "@gemini/icons";
import { useBrowserPrint } from "@/hooks/useBrowserPrint";
import { useI18n } from "@/shared/hooks";
export const PrintCTA = ({ variant }) => {
    const { t } = useI18n();
    const { onBrowserPrint } = useBrowserPrint();
    return (_jsx(Button, { icon: PrintIcon, iconOnly: true, size: "40", onPress: onBrowserPrint, variant: variant, children: t("common.CTA.print.label") }));
};
